import _ from 'lodash';

import { toQuery } from '@/utils/infrastructure';
import { request } from '@/utils/infrastructure/communication';
import { getSessionItem, setSessionItem, STORAGE_KEYS } from '@/utils/infrastructure/auth';

export async function queryCurrent(changeCompany) {
  let user = getSessionItem(STORAGE_KEYS.AUTH_USER);
  if (user && !user.includes('useCache') && !changeCompany) return JSON.parse(user);

  const params = {
    select: 'id,isActive,fullName,names,lastNames,email,role,defaultLanguage',
    expand: {
      company: { select: 'id,name,commercialName,shortCode' },
      position: { select: 'id,name' },
      defaultEnvironment: { select: 'id,name' },
    },
  };

  user = await request('/user/info', { params: toQuery(params) });
  setSessionItem(STORAGE_KEYS.AUTH_USER, JSON.stringify(user));

  return user;
}

export async function queryNotices() {
  return request('/api/notices');
}

export async function recoveryPassword(email) {
  return request('/auth/recoveryPassword', {
    method: 'POST',
    data: { email },
  });
}

export async function updatePassword(data) {
  return request.post('/auth/resetPassword', { data });
}

export async function updateProfilePhoto(content) {
  return request('/account/updateProfilePhoto', {
    method: 'POST',
    data: { content },
  });
}
